import { useTranslation } from 'react-i18next';
import { HELP_CENTER } from '@/consts/links';
import { useAssistNavigationItems } from './subNavigation/useAssistNavigationItems';

export const useAssistNavigationItem = () => {
  const { t } = useTranslation('navigation');

  return {
    id: 'support',
    icon: 'Support' as const,
    label: t('crossPlatform.primary.support'),
    path: HELP_CENTER,
    target: '_blank' as const,
    subNav: useAssistNavigationItems(),
  };
};
